<template>
  <div class="content container-fluid">
    <breadcrumb-index :items="breadcrumbs" />

    <div class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">Add Course</h5>
      </div>
      <div class="card-body">
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Course Name <span class="text-danger">*</span></label>
              <input v-model="form.name" type="text" class="form-control" required />
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Course Code <span class="text-danger">*</span></label>
              <input v-model="form.code" type="text" class="form-control" required />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Category <span class="text-danger">*</span></label>
              <select v-model="form.category" class="form-select" required>
                <option value="">Select Category</option>
                <option value="science">Science</option>
                <option value="mathematics">Mathematics</option>
                <option value="language">Language</option>
                <option value="social">Social Studies</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Status</label>
              <select v-model="form.status" class="form-select">
                <option value="draft">Draft</option>
                <option value="active">Active</option>
              </select>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Description</label>
            <textarea v-model="form.description" class="form-control" rows="3"></textarea>
          </div>

          <div class="mb-3">
            <label class="form-label">Thumbnail</label>
            <input type="file" class="form-control" @change="handleThumbnail" accept="image/*" />
          </div>

          <div v-if="error" class="alert alert-danger">{{ error }}</div>

          <div class="d-flex gap-2">
            <button type="submit" class="btn btn-primary" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
              Create Course
            </button>
            <router-link to="/app/courses/list" class="btn btn-secondary">Cancel</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import api from '@/services/api'
import { useAlert } from '@/plugins/sweetalert'

export default {
  name: 'AddCourse',
  setup() {
    const router = useRouter()
    const alert = useAlert()
    const breadcrumbs = [
      { title: 'Dashboard', url: '/app/dashboard' },
      { title: 'Courses', url: '/app/courses/list' },
      { title: 'Add Course', active: true }
    ]

    const form = ref({ name: '', code: '', category: '', status: 'draft', description: '' })
    const thumbnail = ref(null)
    const loading = ref(false)
    const error = ref('')

    const handleThumbnail = (e) => { thumbnail.value = e.target.files[0] }

    const handleSubmit = async () => {
      loading.value = true
      error.value = ''

      const formData = new FormData()
      Object.keys(form.value).forEach(key => formData.append(key, form.value[key]))
      if (thumbnail.value) formData.append('thumbnail', thumbnail.value)

      try {
        await api.post('/v1/admin/courses', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        alert.success('Success', 'Course created successfully')
        router.push('/app/courses/list')
      } catch (err) {
        error.value = err.response?.data?.message || 'Failed to create course'
      } finally {
        loading.value = false
      }
    }

    return { breadcrumbs, form, loading, error, handleThumbnail, handleSubmit }
  }
}
</script>
